import AbstractScene from './AbstractScene.js';

import TraductionManager from '../prefabs/TraductionManager.js';

export default class Preloader extends AbstractScene {
    constructor() {
        super({
            key: 'Preloader',
        });
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
        this.traductionManager = new TraductionManager();
        // Ajout du texte de chargement
        this.loadingText = this.make.text({
            x: this.width / 2,
            y: this.height / 2,
            resolution: 2,
            text: 'Loading... 0%',
            style: {
                font: '48px DMSansBold',
                fill: '#4393C8',
                stroke: '#FFF',
                strokeThickness: 8,
            },
        });

        this.loadingText.setOrigin(0.5, 0.5);

        this.loadSprites();

        this.load.on('progress', (value) => {
            // this.chargement.setScale(value, 1);
            this.loadingText.text = 'Loading... ' + Math.floor(value * 100) + '%';
        });

        // this.load.on('fileprogress', function (file) {
        // // console.log(file.src);
        // });

        this.load.on(
            'complete',
            function () {
                console.log('Config langue :', this.game.data.langue);
                // if (this.game.data.langue == '' || this.game.data.langue == null) {
                //     this.game.data.langue = this.config.langue;
                // }
                this.traductionManager.setLangue(this.game.data.langue);
                this.traductionManager.init(this);
                this.nextScene();
            },
            this
        );
    }

    loadSprites() {
        // Traduction
        this.traductionManager.loadFile(this, 'assets/traductions_tortue.csv');

        this.load.image('touchUpOn', 'assets/touch-up-on.png');
        this.load.image('touchUpOff', 'assets/touch-up-off.png');
        this.load.image('touchDownOn', 'assets/touch-down-on.png');
        this.load.image('touchDownOff', 'assets/touch-down-off.png');
        this.load.image('backMenu', 'assets/back.png');
        this.load.image('btnFirst', 'assets/btn-first.png');
        this.load.image('btnLast', 'assets/btn-last.png');
        this.load.image('btnValider', 'assets/btn-valider.png');
        this.load.image('btnSuivant', 'assets/btn-suivant.png');
        this.load.image('consigneQuizSolo', 'assets/consigne-quiz-solo.png');
        this.load.image('consigneContainer', 'assets/container-consigne.png');
        this.load.image('btnTuto', 'assets/btn-tuto.png');
        this.load.image('btnSkip', 'assets/btn-skip.png');
        this.load.image('arrow-right', 'assets/arrow-right.png');
        this.load.image('arrow-left', 'assets/arrow-left.png');
        this.load.image('heartFull', 'assets/heart-full.png ');
        this.load.image('heartEmpty', 'assets/heart-empty.png');
        this.load.image('arrowUp', 'assets/arrow-up-01.png');
        this.load.image('arrowDown', 'assets/arrow-down-01.png');
        this.load.image('chrono', 'assets/timer.png');

        this.load.image('goodLogo', 'assets/good.png');
        this.load.image('badLogo', 'assets/bad.png');

        // Charger les textures optimisées pour Android

        // Textures HD normales pour desktop
        this.load.image('fond_part1', 'assets/background/fond_part1.png');
        this.load.image('fond_part2', 'assets/background/fond_part2.png');
        this.load.image('fond_part3', 'assets/background/fond_part3.png');
        this.load.image('fond_part4', 'assets/background/fond_part4.png');
        this.load.image('fond_part5', 'assets/background/fond_part5.png');
        this.load.image('fond_part6', 'assets/background/fond_part6.png');
        this.load.image('fond_part7', 'assets/background/fond_part7.png');
        this.load.image('fond_part8', 'assets/background/fond_part8.png');
        this.load.image('fond_part9', 'assets/background/fond_part9.png');

        this.load.image('plan1_part1', 'assets/background/plan1_part1.png');
        this.load.image('plan1_part2', 'assets/background/plan1_part2.png');
        this.load.image('plan1_part3', 'assets/background/plan1_part3.png');
        this.load.image('plan1_part4', 'assets/background/plan1_part4.png');
        this.load.image('plan1_part5', 'assets/background/plan1_part5.png');
        this.load.image('plan1_part6', 'assets/background/plan1_part6.png');
        this.load.image('plan1_part7', 'assets/background/plan1_part7.png');
        this.load.image('plan1_part8', 'assets/background/plan1_part8.png');
        this.load.image('plan1_part9', 'assets/background/plan1_part9.png');

        this.load.image('plan2_part1', 'assets/background/plan2_part1.png');
        this.load.image('plan2_part2', 'assets/background/plan2_part2.png');
        this.load.image('plan2_part3', 'assets/background/plan2_part3.png');
        this.load.image('plan2_part4', 'assets/background/plan2_part4.png');
        this.load.image('plan2_part5', 'assets/background/plan2_part5.png');
        this.load.image('plan2_part6', 'assets/background/plan2_part6.png');
        this.load.image('plan2_part7', 'assets/background/plan2_part7.png');
        this.load.image('plan2_part8', 'assets/background/plan2_part8.png');
        this.load.image('plan2_part9', 'assets/background/plan2_part9.png');

        this.load.image('plan4_part1', 'assets/background/plan4_part1.png');
        this.load.image('plan4_part2', 'assets/background/plan4_part2.png');
        this.load.image('plan4_part3', 'assets/background/plan4_part3.png');
        this.load.image('plan4_part4', 'assets/background/plan4_part4.png');
        this.load.image('plan4_part5', 'assets/background/plan4_part5.png');
        this.load.image('plan4_part6', 'assets/background/plan4_part6.png');
        this.load.image('plan4_part7', 'assets/background/plan4_part7.png');
        this.load.image('plan4_part8', 'assets/background/plan4_part8.png');
        this.load.image('plan4_part9', 'assets/background/plan4_part9.png');

        this.load.image('bulles_part1', 'assets/background/bulles_part1.png');
        this.load.image('bulles_part2', 'assets/background/bulles_part2.png');
        this.load.image('bulles_part3', 'assets/background/bulles_part3.png');
        this.load.image('bulles_part4', 'assets/background/bulles_part4.png');
        this.load.image('bulles_part5', 'assets/background/bulles_part5.png');
        this.load.image('bulles_part6', 'assets/background/bulles_part6.png');
        this.load.image('bulles_part7', 'assets/background/bulles_part7.png');
        this.load.image('bulles_part8', 'assets/background/bulles_part8.png');
        this.load.image('bulles_part9', 'assets/background/bulles_part9.png');

        this.load.image('casier', 'assets/obstacles/casiers.png');
        this.load.image('dcp', 'assets/obstacles/DCP.png');
        this.load.image('filetMaillant', 'assets/obstacles/filet-maillant.png');
        this.load.image('palangre', 'assets/obstacles/palangre.png');
        this.load.image('resteSenne', 'assets/obstacles/reste-senne.png');

        this.load.spritesheet('poisson1', 'assets/poissons/poisson-1.png', {
            frameWidth: 65,
            frameHeight: 21,
        });
        this.load.spritesheet('poisson2', 'assets/poissons/poisson-2.png', {
            frameWidth: 32,
            frameHeight: 17,
        });
        this.load.spritesheet('poisson3', 'assets/poissons/poisson-3.png', {
            frameWidth: 32,
            frameHeight: 17,
        });
        // this.load.spritesheet('poisson4',
        //     'assets/poissons/poisson-4.png',
        //     { frameWidth: 108.5, frameHeight: 36 }
        // );
        this.load.spritesheet('poisson5', 'assets/poissons/poisson-5.png', {
            frameWidth: 26,
            frameHeight: 8,
        });
        this.load.spritesheet('poisson6', 'assets/poissons/poisson-6.png', {
            frameWidth: 26,
            frameHeight: 8,
        });
        this.load.spritesheet('poisson7', 'assets/poissons/poisson-7.png', {
            frameWidth: 26,
            frameHeight: 8,
        });
        this.load.spritesheet('poisson8', 'assets/poissons/poisson-8.png', {
            frameWidth: 26,
            frameHeight: 8,
        });
        this.load.spritesheet('poisson9', 'assets/poissons/poisson-9.png', {
            frameWidth: 65,
            frameHeight: 17,
        });
        this.load.spritesheet('poisson10', 'assets/poissons/poisson-10.png', {
            frameWidth: 65,
            frameHeight: 21,
        });

        this.load.spritesheet('tortue', 'assets/tortue/tortue.png', {
            frameWidth: 130.26,
            frameHeight: 81,
        });
        this.load.spritesheet('tortueNet', 'assets/tortue/tortue-net.png', {
            frameWidth: 130.5,
            frameHeight: 80,
        });
        // this.load.spritesheet('filetMaillantSprite', 'assets/obstacles/filet-maillant-sprite.png', {
        //     frameWidth: 669 * this.game.data.scaleX,
        //     frameHeight: 490 * this.game.data.scaleY,
        // });
        this.load.image('filetMaillantSprite_part1', 'assets/obstacles/filet-maillant-part1.png');
        this.load.image('filetMaillantSprite_part2', 'assets/obstacles/filet-maillant-part2.png');
        this.load.image('filetMaillantSprite_part3', 'assets/obstacles/filet-maillant-part3.png');
        this.load.image('filetMaillantSprite_part4', 'assets/obstacles/filet-maillant-part4.png');

        this.load.image('icon_tortue', 'assets/icon_tortue.png');
        this.load.image('icon_click', 'assets/icon_click.png');

        this.load.spritesheet('fishSprite', 'assets/poissons/fish-sprite.png', {
            frameWidth: 111 * this.game.data.scaleX,
            frameHeight: 36 * this.game.data.scaleY,
        });
    }
}
